import { useState } from 'react'
import ItemTabs from 'components/ItemTabs'
import EditWorkingDays from './WorkingDays'
import EditHolidays from './Holidays'
import EditDateReservations from './DateReservations'
import EditExceptionalDates from './ExceptionalDates'
import EditCustomMessages from './CustomMessages'
import EditNotifications from './Notifications'
import EditOnlinePayment from './OnlinePayment'
import { ONLINE_PAYMENT_ENABLED } from 'services/features'
import { Container, TabStickyContainer } from '../styles'

export default function EditAgenda (props) {
  const location = props.location
  const configTab = location.state?.configTab ?? 'working_days'
  const isTutorial = location.state?.isTutorial ?? false

  const TAB_LIST = [
    {
      label: 'Dias e horários',
      value: 'working_days',
      component: <EditWorkingDays {...props}/>
    },
    {
      label: 'Feriados',
      value: 'holidays',
      component: <EditHolidays {...props}/>
    },
    {
      label: 'Reservas Cutilei',
      value: 'cutilei_reservations',
      component: <EditDateReservations reservationType='cutilei'/>
    },
    {
      label: 'Reservas online',
      value: 'online_reservations',
      component: <EditDateReservations reservationType='online'/>
    },
    {
      label: 'Datas excepcionais',
      value: 'exceptional_dates',
      component: <EditExceptionalDates/>
    },
    /*
      O sinal do agendamento ainda não foi lançado: em produção a aba não existe, e o salão
      não encontra uma configuração que o link público ainda não vai honrar. Ver
      `services/features.js`.
    */
    ...ONLINE_PAYMENT_ENABLED ? [{
      label: 'Pagamento online',
      value: 'online_payment',
      component: <EditOnlinePayment/>
    }] : [],
    {
      label: 'Mensagens',
      value: 'custom_messages',
      component: <EditCustomMessages/>
    },
    {
      label: 'Notificações',
      value: 'notifications',
      component: <EditNotifications/>
    }
  ].filter (tab => !isTutorial || tab.value === configTab)

  const [selectedTab, setSelectedTab] = useState (configTab ?? TAB_LIST[0].value)

  return (
    <Container style={{paddingTop: 0}}>
      <TabStickyContainer style={{top: 68}}>
        <ItemTabs
          tabs={TAB_LIST}
          selectedTab={selectedTab}
          onTabChange={setSelectedTab}
          containerStyle={{width: 1250, paddingTop: 7}}
          tabWidth={160}
        />
      </TabStickyContainer>
      {TAB_LIST.find (tab => tab.value === selectedTab)?.component}
    </Container>
  )
}
